import type { AppearanceVariant } from '../types';

import { WorldsPreview } from '../previews/worlds';

export const worldsVariant: AppearanceVariant = {
  id: 'worlds',
  nameKey: 'appearance.worlds',
  descriptionKey: 'appearance.worldsDescription',
  className: 'erp-worlds',
  composition: 'sidebar',
  groupedNavigation: true,
  documentEntry: 'guided',
  Preview: WorldsPreview,
};
